import { Navigate } from 'react-router-dom';
import { route } from '../../route/Index';
import { useAppSelector } from '../../store/hook';
import { selectUser } from '../../store/user/userSlice';

interface IisAdmin {}

const isAdmin = <T extends IisAdmin>(WrappedComponent: React.ComponentType<T>) => {
    return (_props: T) => {
        const user = useAppSelector(selectUser);
        if (!user.data?.isAdmin) {
            return <Navigate to={route.info} />;
        }
        return <WrappedComponent {..._props} />;
    };
};

export default isAdmin;
